import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const ImageUploadContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  display: inline-block;
  text-align: center;
  margin-bottom: ${rhythm(2)};
`;

export default ImageUploadContainer;
